import SigamAPI from '~/utils/SigamAPI';

export default async function getTotal({ institutionId }) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/dashboard/subjects/occurrences`,
    method: 'POST',
  });

  return response;
}
